import { Store } from '@betgames/bg-state-manager';

export class FEIMSettingsStore extends Store<{ freeze: boolean }> {
    constructor() {
        super({
            key: 'FEIMSettings',
            default: {
                freeze: false,
            },
        });
    }

    public set freeze(value: boolean) {
        this.update((draft) => {
            draft.freeze = value;
        });
    }
}

export const feimSettingsStore = new FEIMSettingsStore();
